<template>

<app-content :loading="is.loading">

	<app-content-head :title="title" :back="$route.meta.back" :readonly="$authorised('mem/subscriptions/access', 'read')">

		<app-content-head-actions-item :disabled="!isDirty" icon="undo" text="Undo" v-on:click="onUndoClick" />
		<app-content-head-actions-item :loading="is.saving" :disabled="!isDirty || !isValid" icon="save" text="Save" v-on:click="onSaveClick" />
		<app-content-head-actions-item v-if="!isNew" :disabled="isNew" :danger="true" icon="delete" text="Delete" v-on:click="onDeleteClick" />

	</app-content-head>

	<app-content-body v-if="!is.loading">

		<app-content-box :readonly="$authorised('mem/subscriptions/access', 'read')">

			<app-input-text label="Name" placeholder="Enter name..." v-model="model.name" :validation="$v.model.name" maxlength="32" />
            <app-input-text label="About" :autogrow="true" placeholder="(optional) Enter text..." v-model="model.text" notes="Further description of what the tag means." :validation="$v.model.text" />
            <app-input-colour v-model="model.colour" :validation="$v.model.colour" label="Background Color" placeholder="Enter hex" notes="Background colour of tag when shown as alert or label." />
			<app-input-text :toggle="model.label.enabled" v-on:toggle="model.label.enabled = !model.label.enabled" label="Show as Label" v-model="model.label.text" :validation="$v.model.label.text" placeholder="Enter text" maxlength="16" notes="Label to be shown next to subscription in backend." />
			<app-input-text text-suffix="seconds" :toggle="model.alert.enabled" v-on:toggle="model.alert.enabled = !model.alert.enabled" label="Show as Alert" v-model="model.alert.duration" :validation="$v.model.alert.duration" placeholder="Enter seconds (0 = until dismissed)" notes="Alert to be shown when scanned. A value of 0 indiciates manual dismiss required." />
			<app-input-file :toggle="model.sound.enabled" v-on:toggle="model.sound.enabled = !model.sound.enabled" label="Play Sound" v-model="model.sound.file" :validation="$v.model.sound.file" placeholder="Enter text" accept="mp3" notes="Play a sound when scanned during checkin. Must be an mp3 file." />

		</app-content-box>

	</app-content-body>

</app-content>

</template>

<script>

import mixForm from '@/mixin/form'
import { required } from 'vuelidate/lib/validators'

export default {

	mixins: [mixForm],

	data: function() {

		return {
			readonly: this.$authorised('mem/subscriptions/access', 'read'),
			references: {},
			model: {
				id: false,
				name: '',
                colour: '4d5b6e',
                text: '',
                sound: {
                    enabled: false,
                    file: ''
                },
                label: {
                    enabled: false,
                    text: ''
                },
                alert: {
                    enabled: false,
                    duration: 3
                }
			}
		}

	},

	validations: {
		model: {
			name: {
				required
			},
            label: {},
            sound: {},
            alert: {}
		}
	}

}

</script>

<style scoped>

</style>